import React from "react";

export default function Resource() {
  return (
    <div className="agn-resource-wrapper">
      <style>{`
   
        .agn-resource-wrapper {
          padding: var(--section-padding);
          background: #ffffff;
          position: relative;
          overflow: hidden;
        }

        .agn-resource-wrapper::before {
          content: '';
          position: absolute;
          top: -10%;
          right: -10%;
          width: 500px;
          height: 500px;
          background: radial-gradient(circle, rgba(var(--theme-color-rgb), 0.05) 0%, transparent 70%);
          z-index: 0;
        }

        .resource-container {
          position: relative;
          z-index: 1;
        }

        .resource-img-box {
          position: relative;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .resource-img-box::after {
          content: '';
          position: absolute;
          width: 80%;
          height: 80%;
          border: 2px solid rgba(var(--theme-color-rgb), 0.1);
          border-radius: 40px;
          z-index: -1;
          transform: rotate(-5deg);
          transition: all 0.6s ease;
        }

        .resource-img-box:hover::after {
          transform: rotate(0deg) scale(1.05);
          border-color: rgba(var(--theme-color-rgb), 0.3);
        }

        .resource-img {
          border-radius: 40px;
          box-shadow: 0 30px 60px rgba(0, 0, 0, 0.08);
          width: 85%;
          transition: all 0.6s ease;
        }

        .resource-img-box:hover .resource-img {
          transform: translateY(-10px);
        }

        .resource-title h2 {
          font-family: var(--font-primary);
          font-size: var(--h2-size);
          font-weight: var(--h2-weight);
          color: var(--theme-color);
          margin-bottom: 20px;
          line-height: var(--lh-tight);
          letter-spacing: -0.02em;
        }

        .resource-intro {
          font-family: var(--font-secondary);
          font-size: var(--body-size);
          color: #555;
          margin-bottom: 40px;
          line-height: var(--lh-base);
        }

        .resource-list {
          padding: 0;
          list-style: none;
          display: grid;
          gap: 20px;
        }

        .resource-feature-item {
          display: flex;
          align-items: center;
          gap: 20px;
          background: #fcfcfc;
          padding: 20px 25px;
          border-radius: 20px;
          border: 1px solid rgba(0, 0, 0, 0.03);
          transition: all 0.3s ease;
        }

        .resource-feature-item:hover {
          background: #ffffff;
          transform: translateX(10px);
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
          border-color: rgba(var(--theme-color-rgb), 0.2);
        }

        .resource-tick-box {
          width: 40px;
          height: 40px;
          background: rgba(var(--theme-color-rgb), 0.1);
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          transition: all 0.3s ease;
        }

        .resource-feature-item:hover .resource-tick-box {
          background: var(--theme-color);
          transform: scale(1.1) rotate(5deg);
        }

        .resource-tick-box img {
          filter: brightness(0) saturate(100%) invert(75%) sepia(21%) saturate(769%) hue-rotate(346deg) brightness(90%) contrast(88%);
          width: 18px;
          transition: all 0.3s ease;
        }

        .resource-feature-item:hover .resource-tick-box img {
          filter: brightness(0) invert(1);
        }

        .resource-feature-text {
          font-family: var(--font-primary);
          font-size: 1.1rem;
          font-weight: 700;
          color: #222;
        }

        @media (max-width: 991px) {
          .resource-img-box {
            margin-bottom: 50px;
          }
          .resource-title h2, .resource-intro {
            text-align: center;
          }
        }
      `}</style>

      <div className="container resource-container">
        <div className="row align-items-center">
          <div className="col-lg-6">
            <div className="resource-img-box">
              <img
                src="assets/images/img/built_for_scalable.png"
                className="resource-img"
                alt="Scalable Financial Operations"
              />
            </div>
          </div>
          <div className="col-lg-6">
            <div className="resource-content">
              <div className="resource-title">
                <h2>Built for Scalable Financial Operations
                </h2>
              </div>
              <p className="resource-intro">
                AGN operates with a structured ecosystem ensuring:

              </p>

              <ul className="resource-list">
                <li className="resource-feature-item">
                  <div className="resource-tick-box">
                    <img src="../assets/svg/home/tick.svg" alt="tick" />
                  </div>
                  <span className="resource-feature-text">
                    Secure transaction processing
                  </span>
                </li>

                <li className="resource-feature-item">
                  <div className="resource-tick-box">
                    <img src="../assets/svg/home/tick.svg" alt="tick" />
                  </div>
                  <span className="resource-feature-text">
                    Transparent income tracking

                  </span>
                </li>

                <li className="resource-feature-item">
                  <div className="resource-tick-box">
                    <img src="../assets/svg/home/tick.svg" alt="tick" />
                  </div>
                  <span className="resource-feature-text">
                    Efficient asset allocation models
                  </span>
                </li>

                <li className="resource-feature-item">
                  <div className="resource-tick-box">
                    <img src="../assets/svg/home/tick.svg" alt="tick" />
                  </div>
                  <span className="resource-feature-text">
                    Scalable global participation

                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
